import { FDCApprovalGroups } from '../../../cimsPage/instances/fdc'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const groups = CreateViewEditSoftRemoveRestore({
  page: FDCApprovalGroups,
  object: 'Approval Group',
  view: 'afada74d-6cb8-4d1c-92bd-6c7ff85a54a9',
  create: 'e49e40f7-6fff-421c-8071-991c711a789d',
  edit: '11075b20-60e7-4b24-94c9-4f67058959b6',
  removeRestore: '1e6eb0db-2a5e-4f7d-85d9-abe3af6bf1ab',
})

export const ViewFDCApprovalGroup = groups.View
export const CreateFDCApprovalGroup = groups.Create
export const EditFDCApprovalGroup = groups.Edit
export const RemoveRestoreFDCApprovalGroup = groups.RemoveRestore

export type FDCApprovalGroupPermission =
  | typeof ViewFDCApprovalGroup
  | typeof CreateFDCApprovalGroup
  | typeof EditFDCApprovalGroup
  | typeof RemoveRestoreFDCApprovalGroup
